/* Camisetas Futbolero · personalización, carrito con extras enlazados y detalles de UI.
   La camiseta lleva _cf_id; nombre/dorsal y parches van como líneas aparte con _cf_parent. */
import { CartAddEvent, CartUpdateEvent, ThemeEvents } from '@theme/events';

const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const T = {
  needName: 'Escribe un nombre o un dorsal, o desactiva la personalización.',
  max: 'Puedes añadir hasta 3 parches.',
  remove: 'Quitar',
  fail: 'No se ha podido añadir al carrito. Inténtalo de nuevo.',
};
const NAME_BAD = (() => {
  try { return new RegExp("[^\\p{L}' .\\-]", 'gu'); } catch (e) { return /[^A-ZÀ-ÖØ-Þ' .\-]/g; }
})();
const uid = () => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
const esc = (s) => String(s == null ? '' : s).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const currency = () => (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
const money = (cents) => (cents / 100).toLocaleString('es-ES', { style: 'currency', currency: currency() });
const props = (it) => (it && it.properties) || {};
const isExtraHandle = (h) => /^(extra-|option-set-)/.test(h || '');
const cartSectionIds = () =>
  [...document.querySelectorAll('cart-items-component')].map((el) => el.dataset.sectionId).filter(Boolean);
const shirtCount = (cart) =>
  (cart.items || []).reduce((s, it) => s + (!props(it)._cf_parent && !isExtraHandle(it.handle) ? it.quantity : 0), 0);

async function postJSON(url, body) {
  const r = await fetch(ROOT + url, {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  const j = await r.json();
  if (!r.ok) throw j;
  return j;
}

/* ---------- Personalización en la ficha ---------- */
class CfPersonalizacion extends HTMLElement {
  connectedCallback() {
    const q = (s) => this.querySelector(s);
    const qa = (s) => [...this.querySelectorAll(s)];
    this.q = q;
    this.qa = qa;
    try { this.variants = JSON.parse(q('[data-cf-variants]').textContent); } catch (e) { this.variants = {}; }
    this.ND = { id: +this.dataset.ndVariant, price: +this.dataset.ndPrice };
    this.PA = { id: +this.dataset.paVariant, price: +this.dataset.paPrice };
    this.MAX = +this.dataset.max || 3;
    this.state = { fit: this.dataset.kids === 'true' ? null : 'Hombre', patches: [], others: [] };

    this.toggle = q('[data-cf-toggle]');
    this.pers = q('[data-cf-pers]');
    this.nameIn = q('[data-cf-name]');
    this.numIn = q('[data-cf-num]');
    this.ptoggle = q('[data-cf-ptoggle]');
    this.ppanel = q('[data-cf-ppanel]');
    this.otherIn = q('[data-cf-other]');
    this.chips = q('[data-cf-chips]');
    this.err = q('[data-cf-error]');
    this.persErr = q('[data-cf-pers-error]');
    this.summary = q('[data-cf-summary]');
    this.genErr = q('[data-cf-gen-error]');

    const wrap = q('[data-cf-patches]');
    qa('[data-cf-patch]')
      .sort((a, b) => (+a.dataset.order || 99) - (+b.dataset.order || 99))
      .forEach((b) => wrap.appendChild(b));
    if (!wrap.children.length) wrap.hidden = true;

    qa('[data-cf-fit]').forEach((b) =>
      b.addEventListener('click', () => {
        qa('[data-cf-fit]').forEach((x) => { x.classList.remove('is-on'); x.setAttribute('aria-checked', 'false'); });
        b.classList.add('is-on');
        b.setAttribute('aria-checked', 'true');
        this.state.fit = b.dataset.cfFit;
      })
    );

    this.toggle.addEventListener('click', () => {
      const on = !this.isOn();
      this.toggle.setAttribute('aria-checked', String(on));
      this.pers.hidden = !on;
      this.persErr.textContent = '';
      if (on) { try { this.nameIn.focus({ preventScroll: true }); } catch (e) {} }
      this.refresh();
    });
    this.nameIn.addEventListener('input', () => {
      const pos = this.nameIn.selectionStart;
      this.nameIn.value = this.nameIn.value.toUpperCase().replace(NAME_BAD, '');
      try { this.nameIn.setSelectionRange(pos, pos); } catch (e) {}
      this.persErr.textContent = '';
      this.refresh();
    });
    this.numIn.addEventListener('input', () => {
      this.numIn.value = this.numIn.value.replace(/\D/g, '').slice(0, 2);
      this.persErr.textContent = '';
      this.refresh();
    });
    qa('[data-cf-suggest]').forEach((b) =>
      b.addEventListener('click', () => {
        this.nameIn.value = b.dataset.name || '';
        this.numIn.value = b.dataset.num || '';
        this.persErr.textContent = '';
        this.refresh();
      })
    );

    this.ptoggle.addEventListener('click', () => {
      const on = this.ptoggle.getAttribute('aria-checked') !== 'true';
      this.ptoggle.setAttribute('aria-checked', String(on));
      this.ppanel.hidden = !on;
      if (!on) {
        this.state.patches = [];
        this.state.others = [];
        this.otherIn.value = '';
        qa('[data-cf-patch]').forEach((b) => { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
        this.renderChips();
        this.setErr('');
      }
      this.refresh();
    });
    qa('[data-cf-patch]').forEach((b) =>
      b.addEventListener('click', () => {
        const n = b.dataset.cfPatch;
        const i = this.state.patches.indexOf(n);
        if (i > -1) {
          this.state.patches.splice(i, 1);
          b.classList.remove('is-on');
          b.setAttribute('aria-pressed', 'false');
        } else {
          if (this.total() >= this.MAX) return this.setErr(T.max);
          this.state.patches.push(n);
          b.classList.add('is-on');
          b.setAttribute('aria-pressed', 'true');
        }
        this.setErr('');
        this.refresh();
      })
    );
    q('[data-cf-other-add]').addEventListener('click', () => this.addOther());
    this.chips.addEventListener('click', (e) => {
      const b = e.target.closest('button[data-i]');
      if (!b) return;
      this.state.others.splice(+b.dataset.i, 1);
      this.renderChips();
      this.setErr('');
      this.refresh();
    });
    [this.nameIn, this.numIn, this.otherIn].forEach((el) =>
      el.addEventListener('keydown', (e) => {
        if (e.key !== 'Enter') return;
        e.preventDefault();
        if (el === this.otherIn) this.addOther(); else el.blur();
      })
    );

    this.section = this.closest('.shopify-section') || document;
    this.section.addEventListener('change', () => setTimeout(() => this.refresh(), 60));
    document.addEventListener(ThemeEvents.variantUpdate, () => setTimeout(() => this.refresh(), 60));
    this.refresh();
  }

  isOn() { return this.toggle.getAttribute('aria-checked') === 'true'; }
  name() { return (this.nameIn.value || '').trim().toUpperCase(); }
  num() { return (this.numIn.value || '').replace(/\D/g, ''); }
  persActive() { return this.isOn() && !!(this.name() || this.num()); }
  total() { return this.state.patches.length + this.state.others.length; }
  allPatches() { return this.state.patches.concat(this.state.others); }
  form() {
    return this.section.querySelector('form[data-type="add-to-cart-form"]');
  }
  variantId() {
    const f = this.form();
    const i = f && f.querySelector('[name="id"]');
    return i ? i.value : null;
  }
  qty() {
    const f = this.form();
    const i = f && f.querySelector('[name="quantity"]');
    const n = parseInt(i && i.value, 10);
    return n > 0 ? n : 1;
  }
  setErr(msg) { this.err.textContent = msg || ''; }

  renderChips() {
    this.chips.innerHTML = this.state.others
      .map((o, i) => `<span class="cf__chip">${esc(o)}<button type="button" data-i="${i}" aria-label="${T.remove} ${esc(o)}">×</button></span>`)
      .join('');
  }
  addOther() {
    const v = (this.otherIn.value || '').trim().replace(/\s+/g, ' ');
    if (!v) return true;
    if (this.total() >= this.MAX) { this.setErr(T.max); return false; }
    if (this.state.others.indexOf(v) === -1) this.state.others.push(v);
    this.otherIn.value = '';
    this.renderChips();
    this.setErr('');
    this.refresh();
    return true;
  }

  refresh() {
    const pers = this.persActive();
    const np = this.allPatches().length;
    const v = this.variants[this.variantId()] || {};
    const base = v.price || 0;
    const extras = (pers ? this.ND.price : 0) + np * this.PA.price;
    document.documentElement.classList.toggle('cf-con-extras', pers || np > 0);
    if (!pers && !np) { this.summary.hidden = true; return; }
    const parts = [];
    if (pers) parts.push(`Se estampará: <strong>${esc([this.name(), this.num()].filter(Boolean).join(' · '))}</strong>`);
    if (np) parts.push(`${np} parche${np > 1 ? 's' : ''}: ${esc(this.allPatches().join(', '))}`);
    this.summary.innerHTML =
      `<span>${parts.join('<br>')}</span><span class="cf__sum-total">Total ${money((base + extras) * this.qty())}</span>`;
    this.summary.hidden = false;
  }

  validate() {
    if (this.isOn() && !this.name() && !this.num()) {
      this.persErr.textContent = T.needName;
      try { this.nameIn.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
      setTimeout(() => this.nameIn.focus({ preventScroll: true }), 300);
      return false;
    }
    return this.addOther();
  }

  build(variantId, n) {
    const v = this.variants[variantId] || {};
    const shirt = this.dataset.title + (v.title && v.title.indexOf('Default') === -1 ? ' · ' + v.title : '');
    const id = uid();
    const p = {};
    if (this.state.fit) p.Tallaje = this.state.fit;
    const withPers = this.persActive();
    if (withPers) { if (this.name()) p.Nombre = this.name(); if (this.num()) p.Dorsal = this.num(); }
    if (this.state.patches.length) p.Parches = this.state.patches.join(', ');
    if (this.state.others.length) p['Otros parches'] = this.state.others.join(', ');
    const all = this.allPatches();
    if (withPers || all.length) p._cf_id = id;
    const items = [{ id: +variantId, quantity: n, properties: p }];
    if (withPers)
      items.push({ id: this.ND.id, quantity: n, properties: { Camiseta: shirt, 'Personalización': [this.name(), this.num()].filter(Boolean).join(' '), _cf_parent: id, _cf_unit: '1' } });
    if (all.length)
      items.push({ id: this.PA.id, quantity: n * all.length, properties: { Camiseta: shirt, Parches: all.join(', '), _cf_parent: id, _cf_unit: String(all.length) } });
    return items;
  }

  async addToCart(form) {
    const id = this.variantId();
    if (!id) return;
    const n = this.qty();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.setAttribute('aria-busy', 'true');
    this.genErr.textContent = '';
    try {
      const res = await postJSON('cart/add.js', { items: this.build(id, n), sections: cartSectionIds().join(',') });
      this.otherIn.value = '';
      const pfc = form.closest('product-form-component') || form;
      pfc.dispatchEvent(
        new CartAddEvent({}, String(id), {
          source: 'product-form-component',
          itemCount: n,
          productId: pfc.dataset && pfc.dataset.productId,
          variantId: String(id),
          sections: res.sections,
        })
      );
    } catch (e) {
      this.genErr.textContent = (e && (e.description || e.message)) || T.fail;
    } finally {
      if (btn) btn.removeAttribute('aria-busy');
    }
  }
}
if (!customElements.get('cf-personalizacion')) customElements.define('cf-personalizacion', CfPersonalizacion);

/* Interceptar el botón y el envío del formulario de la ficha antes que el tema */
const cfFor = (el) => {
  const sec = el && el.closest('.shopify-section');
  const cf = sec && sec.querySelector('cf-personalizacion');
  return cf && cf.form() && cf.form().contains(el) ? cf : null;
};
window.addEventListener(
  'click',
  (e) => {
    const b = e.target.closest && e.target.closest('form[data-type="add-to-cart-form"] [type="submit"]');
    const cf = b && cfFor(b);
    if (cf && !cf.validate()) { e.preventDefault(); e.stopImmediatePropagation(); }
  },
  true
);
window.addEventListener(
  'submit',
  (e) => {
    const f = e.target;
    if (!(f instanceof HTMLFormElement) || f.dataset.type !== 'add-to-cart-form') return;
    const cf = cfFor(f);
    if (!cf) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!cf.validate()) return;
    cf.addToCart(f);
  },
  true
);

/* ---------- Carrito: mantener los extras enlazados a su camiseta ---------- */
let syncing = false;
async function cfSync() {
  if (syncing) return;
  syncing = true;
  try {
    const cart = await (await fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();
    const parents = {};
    (cart.items || []).forEach((it) => {
      const p = props(it);
      if (p._cf_id) parents[p._cf_id] = (parents[p._cf_id] || 0) + it.quantity;
    });
    const updates = {};
    let n = 0;
    (cart.items || []).forEach((it) => {
      const p = props(it);
      if (p._cf_parent) {
        const exp = (parents[p._cf_parent] || 0) * (parseInt(p._cf_unit, 10) || 1);
        if (exp !== it.quantity) { updates[it.key] = exp; n++; }
      } else if (isExtraHandle(it.handle)) {
        updates[it.key] = 0; /* extras sueltos sin camiseta */
        n++;
      }
    });
    if (!n) return;
    const c = await postJSON('cart/update.js', { updates, sections: cartSectionIds().join(',') });
    document.dispatchEvent(new CartUpdateEvent(c, 'cf-sync', { source: 'cf-sync', itemCount: shirtCount(c), sections: c.sections }));
  } catch (e) {
    /* silencioso: el carrito sigue funcionando */
  } finally {
    syncing = false;
  }
}
document.addEventListener(ThemeEvents.cartUpdate, (e) => {
  const d = e.detail || {};
  if (d.sourceId === 'cf-sync' || (d.data && d.data.source === 'cf-sync')) return;
  setTimeout(cfSync, 80);
});
if (document.body.dataset.cfCart === 'extras') setTimeout(cfSync, 400);

/* ---------- "Leer más" en textos largos ---------- */
document.querySelectorAll('[data-cf-clamp]').forEach((box) => {
  const btn = box.parentElement.querySelector('[data-cf-clamp-btn]');
  if (!btn) return;
  requestAnimationFrame(() => {
    if (box.scrollHeight - box.clientHeight < 8) { box.classList.add('is-open'); return; }
    btn.hidden = false;
    const more = btn.textContent;
    btn.addEventListener('click', () => {
      const open = box.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', String(open));
      btn.textContent = open ? 'Ver menos' : more;
    });
  });
});

/* ---------- Guía de tallas ---------- */
document.addEventListener('click', (e) => {
  const open = e.target.closest && e.target.closest('[data-cf-sg-open]');
  if (open) { const d = document.getElementById(open.dataset.cfSgOpen); if (d && d.showModal) d.showModal(); return; }
  const close = e.target.closest && e.target.closest('[data-cf-sg-close]');
  if (close) { close.closest('dialog').close(); return; }
  if (e.target.matches && e.target.matches('dialog.cf-sg-dialog')) { e.target.close(); return; }
  const tab = e.target.closest && e.target.closest('[data-cf-sg-tab]');
  if (tab) {
    const box = tab.closest('[data-cf-sg]');
    box.querySelectorAll('[data-cf-sg-tab]').forEach((b) => b.setAttribute('aria-selected', String(b === tab)));
    box.querySelectorAll('[data-cf-sg-panel]').forEach((p) => { p.hidden = p.dataset.cfSgPanel !== tab.dataset.cfSgTab; });
  }
});

/* ---------- Oferta del pack en la ficha (mismos textos que el tema anterior) ---------- */
const tiersOf = (s) => String(s || '').split(',').map((x) => x.split(':').map(Number))
  .filter((a) => a[0] > 1 && a[1] > 0 && a[1] < 100).sort((a, b) => a[0] - b[0]);
const TIERS = tiersOf(window.CF_DATA && window.CF_DATA.tiers);
const tierFor = (n) => { let d = 0; TIERS.forEach((t) => { if (n >= t[0]) d = t[1]; }); return d; };
const nextTier = (n) => TIERS.find((t) => n < t[0]) || null;
const getCart = async () => (await fetch(ROOT + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })).json();

async function refreshOffer() {
  const el = document.querySelector('[data-cf-offer-text]');
  if (!el || !TIERS.length) return;
  try {
    const c = shirtCount(await getCart());
    const withThis = c + 1, d = tierFor(withThis), nx = nextTier(withThis);
    if (c > 0 && d) el.textContent = `Con esta camiseta ahorras un ${d} % en todas (llevas ${c} en el carrito)`;
    else if (c > 0 && nx) el.textContent = `Llévate ${nx[0] - withThis} más y ahorra un ${nx[1]} %, combinando equipos`;
  } catch (e) {}
}
refreshOffer();
document.addEventListener(ThemeEvents.cartUpdate, () => setTimeout(refreshOffer, 300));

/* ---------- Carrito lateral: "Completa tu pack" (igual que el tema anterior) ---------- */
const recCache = {};
const isKidsP = (p) => (p.tags || []).some((t) => /^(niños|ninos|niño|kids)$/i.test(t));
const isExtraP = (p) => /^(extra-|option-set-)/.test(p.handle || '') ||
  (p.tags || []).some((t) => /extra-personalizacion|globo-product-options|sin-personalizacion/.test(t));
const recsFor = (pid) => recCache[pid] || (recCache[pid] =
  fetch(`${ROOT}recommendations/products.json?product_id=${pid}&limit=10&intent=related`, { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.json() : { products: [] })).then((j) => j.products || []).catch(() => []));
const imgW = (src, w) => {
  if (!src) return '';
  src = String(src); if (src.indexOf('//') === 0) src = 'https:' + src;
  return src.replace(/(\.(?:jpe?g|png|webp|gif))(\?|$)/i, `_${w}x$1$2`);
};

function upsellHtml(list, cart) {
  const n = shirtCount(cart), d = tierFor(n + 1), nx = nextTier(n);
  const sub = nx ? `Añade otra y ahorra un ${nx[1]} % en todas` : `Llevas el ${d} % en todas`;
  const ND = window.CF_DATA && window.CF_DATA.nd, PA = window.CF_DATA && window.CF_DATA.pa;
  const cards = list.map((p) => {
    const vs = (p.variants || []).filter((v) => v.available);
    if (!vs.length) return '';
    const price = vs[0].price, now = Math.round(price * (100 - d) / 100);
    const opts = vs.map((v) => `<option value="${v.id}">${esc(v.title)}</option>`).join('');
    const url = p.url || `/products/${p.handle}`;
    return `<div class="cf-up__item" data-cf-up-item data-title="${esc(p.title)}">
      <a class="cf-up__img" href="${esc(url)}"><img src="${esc(imgW(p.featured_image, 160))}" alt="" loading="lazy" width="72" height="72"></a>
      <div class="cf-up__body"><a class="cf-up__name" href="${esc(url)}">${esc(p.title)}</a>
      <div class="cf-up__price">${d ? `<s>${money(price)}</s> ` : ''}<strong>${money(now)}</strong></div>
      <div class="cf-up__row"><select class="cf-up__sel" data-cf-up-size aria-label="Talla"><option value="">Talla</option>${opts}</select>
      ${isKidsP(p) ? '' : '<select class="cf-up__sel" data-cf-up-fit aria-label="Tallaje"><option>Hombre</option><option>Mujer</option></select>'}</div>
      ${ND ? `<button type="button" class="cf-up__opt" data-cf-up-pers>+ Nombre y dorsal <span>+${money(ND.price)}</span></button>
        <div class="cf-up__persf" data-cf-up-persf hidden><input type="text" maxlength="14" autocomplete="off" autocapitalize="characters" placeholder="Nombre" data-cf-up-name><input type="text" inputmode="numeric" maxlength="2" autocomplete="off" placeholder="Dorsal" data-cf-up-num></div>` : ''}
      ${PA ? `<button type="button" class="cf-up__opt" data-cf-up-ptog data-handle="${esc(p.handle)}">+ Parches <span>+${money(PA.price)} c/u · máx. 3</span></button>
        <div class="cf-up__patches" data-cf-up-patches hidden></div>` : ''}
      <button type="button" class="cf-up__add" data-cf-up-add>Añadir</button>
      <div class="cf-up__err" data-cf-up-err hidden></div></div></div>`;
  }).filter(Boolean);
  if (!cards.length) return '';
  return `<div class="cf-up" data-cf-up><div class="cf-up__head"><strong>Completa tu pack</strong><span>${esc(sub)}</span></div><div class="cf-up__list">${cards.slice(0, 4).join('')}</div></div>`;
}

let upTimer;
async function placeUpsell() {
  const slot = document.querySelector('cart-drawer-component [data-cf-up-slot]');
  if (!slot || !TIERS.length) return;
  try {
    const cart = await getCart();
    const shirts = (cart.items || []).filter((it) => !props(it)._cf_parent && !isExtraHandle(it.handle));
    if (!shirts.length) { slot.innerHTML = ''; return; }
    const inCart = {}; cart.items.forEach((it) => { inCart[it.product_id] = 1; });
    let list = await recsFor(shirts[0].product_id); /* lo último añadido va primero */
    list = list.filter((p) => !inCart[p.id] && !isExtraP(p));
    const s = document.querySelector('cart-drawer-component [data-cf-up-slot]');
    if (s) s.innerHTML = upsellHtml(list, cart);
  } catch (e) {}
}
const schedUpsell = () => { clearTimeout(upTimer); upTimer = setTimeout(placeUpsell, 250); };
document.addEventListener(ThemeEvents.cartUpdate, schedUpsell);
new MutationObserver(() => {
  const s = document.querySelector('cart-drawer-component [data-cf-up-slot]');
  if (s && !s.childElementCount && !s.dataset.cfBusy) schedUpsell();
}).observe(document.documentElement, { subtree: true, childList: true });
schedUpsell();

document.addEventListener('click', async (e) => {
  const t = e.target;
  const pers = t.closest && t.closest('[data-cf-up-pers]');
  if (pers) {
    const f = pers.parentNode.querySelector('[data-cf-up-persf]');
    f.hidden = !f.hidden; pers.classList.toggle('is-on', !f.hidden);
    if (!f.hidden) setTimeout(() => f.querySelector('input').focus(), 50);
    return;
  }
  const ptog = t.closest && t.closest('[data-cf-up-ptog]');
  if (ptog) {
    const box = ptog.parentNode.querySelector('[data-cf-up-patches]');
    box.hidden = !box.hidden; ptog.classList.toggle('is-on', !box.hidden);
    if (!box.hidden && !box.dataset.loaded) {
      box.dataset.loaded = '1';
      let list = [];
      try { list = (JSON.parse(await (await fetch(`${ROOT}products/${encodeURIComponent(ptog.dataset.handle)}?view=cfdata`, { credentials: 'same-origin' })).text()).patches) || []; } catch (er) {}
      list.sort((a, b) => (+a.o || 99) - (+b.o || 99));
      box.innerHTML = list.map((pt) => `<button type="button" class="cf-up__chip" data-cf-up-patch="${esc(pt.n)}" aria-pressed="false">${pt.img ? `<img src="${esc(pt.img)}" alt="" width="22" height="22" loading="lazy">` : ''}${esc(pt.n)}</button>`).join('') +
        '<input type="text" maxlength="40" autocomplete="off" placeholder="Otro parche (ej: LaLiga 96-97)" data-cf-up-other>';
    }
    return;
  }
  const chip = t.closest && t.closest('[data-cf-up-patch]');
  if (chip) {
    const wrap = chip.parentNode, on = chip.getAttribute('aria-pressed') !== 'true';
    const oth = wrap.querySelector('[data-cf-up-other]');
    const used = wrap.querySelectorAll('[data-cf-up-patch][aria-pressed="true"]').length + (oth && oth.value.trim() ? 1 : 0);
    const errB = wrap.parentNode.querySelector('[data-cf-up-err]');
    if (on && used >= 3) { errB.textContent = T.max; errB.hidden = false; return; }
    errB.hidden = true;
    chip.setAttribute('aria-pressed', String(on)); chip.classList.toggle('is-on', on);
    return;
  }
  const add = t.closest && t.closest('[data-cf-up-add]');
  if (!add || add.disabled) return;
  const ND = window.CF_DATA.nd, PA = window.CF_DATA.pa;
  const card = add.closest('[data-cf-up-item]');
  const sel = card.querySelector('[data-cf-up-size]'), fit = card.querySelector('[data-cf-up-fit]');
  const err = card.querySelector('[data-cf-up-err]');
  err.hidden = true;
  if (!sel.value) { sel.classList.add('is-err'); sel.focus(); return; }
  const nm = card.querySelector('[data-cf-up-name]'), nu = card.querySelector('[data-cf-up-num]');
  const pf = card.querySelector('[data-cf-up-persf]');
  const name = nm && !pf.hidden ? nm.value.trim().toUpperCase() : '';
  const num = nu && !pf.hidden ? nu.value.replace(/\D/g, '') : '';
  const vtitle = sel.options[sel.selectedIndex].text;
  const p = {};
  if (fit) p.Tallaje = fit.value;
  const items = [{ id: +sel.value, quantity: 1, properties: p }];
  const pbox = card.querySelector('[data-cf-up-patches]');
  const chosen = pbox && !pbox.hidden ? [...pbox.querySelectorAll('[data-cf-up-patch][aria-pressed="true"]')].map((b) => b.dataset.cfUpPatch) : [];
  const otherIn = pbox && !pbox.hidden && pbox.querySelector('[data-cf-up-other]');
  const other = otherIn ? otherIn.value.trim() : '';
  if (chosen.length + (other ? 1 : 0) > 3) { err.textContent = T.max; err.hidden = false; return; }
  const id = uid();
  if (chosen.length || other) {
    if (chosen.length) p.Parches = chosen.join(', ');
    if (other) p['Otros parches'] = other;
    const allP = chosen.concat(other ? [other] : []);
    p._cf_id = id;
    if (PA) items.push({ id: PA.id, quantity: allP.length, properties: { Camiseta: card.dataset.title + ' · ' + vtitle, Parches: allP.join(', '), _cf_parent: id, _cf_unit: String(allP.length) } });
  }
  if ((name || num) && ND) {
    if (name) p.Nombre = name;
    if (num) p.Dorsal = num;
    p._cf_id = id;
    items.splice(1, 0, { id: ND.id, quantity: 1, properties: { Camiseta: card.dataset.title + ' · ' + vtitle, 'Personalización': [name, num].filter(Boolean).join(' '), _cf_parent: id, _cf_unit: '1' } });
  }
  add.disabled = true; add.textContent = 'Añadiendo…';
  try {
    const res = await postJSON('cart/add.js', { items, sections: cartSectionIds().join(',') });
    const c = await getCart();
    document.dispatchEvent(new CartUpdateEvent(c, 'cf-up', { source: 'cf-up', itemCount: shirtCount(c), sections: res.sections }));
  } catch (er) {
    add.disabled = false; add.textContent = 'Añadir'; err.textContent = 'No se ha podido añadir. Inténtalo de nuevo.'; err.hidden = false;
  }
});
document.addEventListener('change', (e) => { if (e.target.matches && e.target.matches('[data-cf-up-size]')) e.target.classList.remove('is-err'); });
document.addEventListener('input', (e) => {
  const t = e.target;
  if (t.matches && t.matches('[data-cf-up-name]')) { const v = t.value.toUpperCase().replace(NAME_BAD, ''); if (v !== t.value) t.value = v; }
  if (t.matches && t.matches('[data-cf-up-num]')) { const w = t.value.replace(/\D/g, '').slice(0, 2); if (w !== t.value) t.value = w; }
});
